module.exports = __webpack_public_path__ + "img/xiazai02@2x.e0a4f9f6.png";